<template>
  <div>
    <router-link
      v-if="!isRoleTeacher && checkPermission(permissions.edit)"
      :to="{ name: zoom_meeting_names.detailPage, params: { id: getId(item) } }"
    >
      <md-button class="md-just-icon md-success md-simple table-action ">
        <md-tooltip md-direction="top"
          >{{
            checkPermission(permissions.edit)
              ? $t("common.edit")
              : $t("common.view")
          }}
        </md-tooltip>
        <md-icon>edit</md-icon>
        <md-icon
          v-if="
            checkPermission(permissions.view) &&
              !checkPermission(permissions.edit)
          "
          >visibility</md-icon
        >
      </md-button>
    </router-link>

    <md-button
      v-if="!isRoleTeacher && checkPermission(permissions.delete)"
      class="md-just-icon md-danger md-simple table-action"
      @click.native="triggerConfirmDelete"
    >
      <md-tooltip md-direction="top">{{ $t("common.delete") }} </md-tooltip>
      <md-icon>close</md-icon>
    </md-button>
    <router-link
      v-if="checkPermission(permissions.report)"
      :to="{ name: zoom_meeting_names.reportPage, params: { id: getId(item) } }"
    >
      <md-button class="md-just-icon md-primary md-simple table-action ">
        <md-tooltip md-direction="top">{{ $t("common.report") }} </md-tooltip>
        <md-icon>equalizer</md-icon>
      </md-button>
    </router-link>
  </div>
</template>

<script>
import { service_paths } from "@/constants/Services";
import { zoom_meeting_names } from "@/routes/routes";
import { getId } from "@/helpers/utils";
import { ZoomMeeting } from "@/constants/Permissions";
import { mapGetters } from "vuex";
import { hasValidRole } from "@/helpers/role-helper";
import Role from "@/constants/Role";
const PERMISSION = {
  edit: "edit",
  delete: "delete",
  view: "view",
  report: "report"
};
export default {
  props: ["item"],
  data() {
    return {
      path: service_paths.terms,
      zoom_meeting_names,
      getId,
      permissions: PERMISSION
    };
  },
  computed: {
    ...mapGetters("user", {
      userRole: "role"
    }),
    currentRoute() {
      return this.$route.path.endsWith("/")
        ? this.$route.path.slice(0, -1)
        : this.$route.path;
    },
    isRoleTeacher() {
      return hasValidRole(this.userRole, [Role.Teacher]);
    }
  },
  inject: ["confirmDelete"],
  methods: {
    triggerConfirmDelete() {
      this.confirmDelete(this.item);
    },
    checkPermission(permission) {
      return this.$can(ZoomMeeting.actions[permission], ZoomMeeting.subject);
    }
  }
};
</script>

<style lang="scss" scoped>
.table-action {
  padding: 0 5px;
  margin: 0 2px;
}
</style>
